export default {
  not_started:
    'Configura il tuo account per i pagamenti — la tua quota di ricavi è sospesa finché non viene verificato.',
  bank_account_missing:
    'Aggiungi un conto bancario per i pagamenti — la tua quota di ricavi è sospesa finché non lo fai.',
  incomplete:
    'Il tuo account per i pagamenti non è ancora completamente verificato — la tua quota di ricavi è sospesa finché non lo sarà.',
  add_bank_account: 'Aggiungi conto bancario',
  cta: 'Completa la configurazione',
};
